import { MetricsMetaTypes } from '@pulse/metrics';
import { DEFAULT_METRIC } from '@utils/constants';

const getReplacementMetricId = (metricId: string, userDefinedMetrics: string[]) => {
  // convert metrics like 2_1, 3_1 to m_2, m_3
  if (metricId.includes('_') && !metricId.startsWith('m_')) {
    const splitMetric = metricId.split('_');
    const desiredMetric = `m_${splitMetric[0]}`;
    if (userDefinedMetrics.includes(desiredMetric)) {
      return desiredMetric;
    }
  }
  return metricId;
};

const removeDeletedMetrics = (metrics: string[], metricsList: string[]) => {
  return metrics.filter((metric) => metricsList.includes(metric));
};

// this has temporary fix for the issue of user defined metrics not being consistent when the version changed
// This also has a fix if a metric is deleted from user defined list and the metrics are saved in saved and shared dashboards
// the sanitize function will remove any user defined metrics that are no longer available and replaces removed metrics with the default metric for orderby
// this function also removes the metrics which are deleted from the metric list and also replaces the metric id with new format if available

export const sanitizeUserDefinedMetrics = (
  state: any,
  allMetrics: {
    [name: string]: MetricsMetaTypes;
  },
) => {
  const allMetricsArray: MetricsMetaTypes[] = Object.values(allMetrics);
  const allMetricIds: string[] = allMetricsArray.map((metric) => metric.name);
  const userDefinedMetricIds: string[] = allMetricsArray.reduce(
    (acc: string[], metric: MetricsMetaTypes): any => {
      if (['ECO_USER_DEFINED_METRICS'].includes(metric.category)) {
        acc.push(metric.name);
      }
      return acc;
    },
    [],
  );
  if (state.metricsChartContainer) {
    if (state.metricsChartContainer.metrics.length > 0) {
      const selectedMetrics = state.metricsChartContainer.metrics;
      const newMetrics = selectedMetrics.map((metric) =>
        getReplacementMetricId(metric, userDefinedMetricIds),
      );
      const sanitizedMetrics = removeDeletedMetrics(newMetrics, allMetricIds);
      state.metricsChartContainer.metrics = sanitizedMetrics;
    }
    if (state.metricsChartContainer.metric) {
      const replacementMetric = getReplacementMetricId(
        state.metricsChartContainer.metric,
        userDefinedMetricIds,
      );
      allMetricIds.includes(replacementMetric)
        ? (state.metricsChartContainer.metric = replacementMetric)
        : (state.metricsChartContainer.metric = DEFAULT_METRIC);
    }
  }
  if (state.dimensionTables) {
    if (state.dimensionTables.dimensionSortByMetric) {
      const replacementMetric = getReplacementMetricId(
        state.dimensionTables.dimensionSortByMetric,
        userDefinedMetricIds,
      );
      allMetricIds.includes(replacementMetric)
        ? (state.dimensionTables.dimensionSortByMetric = replacementMetric)
        : (state.dimensionTables.dimensionSortByMetric = DEFAULT_METRIC);
    }
    if (state.dimensionTables.metrics.length > 0) {
      const selectedMetrics = state.dimensionTables.metrics;
      const newMetrics = selectedMetrics.map((metric) =>
        getReplacementMetricId(metric, userDefinedMetricIds),
      );
      const sanitizedMetrics = removeDeletedMetrics(newMetrics, allMetricIds);
      state.dimensionTables.metrics = sanitizedMetrics;
    }
  }
  if (state['module:trends'] && state['module:trends'].base) {
    if (
      state['module:trends'].base.dimensionMetrics &&
      state['module:trends'].base.dimensionMetrics.length > 0
    ) {
      const selectedMetrics = state['module:trends'].base.dimensionMetrics;
      const newMetrics = selectedMetrics.map((metric) =>
        getReplacementMetricId(metric, userDefinedMetricIds),
      );
      const sanitizedMetrics = removeDeletedMetrics(newMetrics, allMetricIds);
      state['module:trends'].base.dimensionMetrics = sanitizedMetrics;
    }
    if (state['module:trends'].base.globalOrderBy) {
      const replacementMetric = getReplacementMetricId(
        state['module:trends'].base.globalOrderBy,
        userDefinedMetricIds,
      );
      allMetricIds.includes(replacementMetric)
        ? (state['module:trends'].base.globalOrderBy = replacementMetric)
        : (state['module:trends'].base.globalOrderBy = DEFAULT_METRIC);
    }
  }
  return state;
};
